import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: export your report. Started from the lesson page in a new
 * tab; never auto-started. The officer opens one of their own reports; no step
 * asks them to click an export button, so nothing is downloaded or deleted.
 */
const tour: TutorialDefinition = {
  id: "export-your-report",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Export your report",
  description: "Find the Export menu and see what each option does.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "export-your-report",
  autoStart: false,
  steps: [
    {
      target: sel("caseListItem"),
      title: "Open a report",
      content: "Click any report that has a draft. Clear leftover placeholders first, because an export still contains them.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("caseListItem"), event: "click" },
      hint: "Open a report to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorExport"),
      waitFor: sel("editorExport"),
      waitTimeoutMs: 10000,
      title: "The Export button",
      content: "Click Export at the right end of the editor toolbar to open the menu. We will not download anything on this tour.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: { selector: sel("editorExport"), event: "click" },
      hint: "Click Export to continue",
      spotlightClicks: true,
    },
    {
      target: sel("editorExport"),
      title: "Pick the export for where it is going",
      content:
        "Copy to Clipboard is the fastest way into your RMS. PDF Document and Word Document are for attachments, E-mail sends it for you, and Transcription exports the transcript on its own when the case has one.",
      disableBeacon: true,
      placement: "bottom",
    },
    {
      target: sel("editorExport"),
      title: "Read each dialog before you agree",
      content:
        "Every dialog has Export with redactions. Some departments also check Delete case upon export, which is your agency's retention policy, so confirm the export worked before you close the tab.",
      disableBeacon: true,
      placement: "bottom",
    },
  ],
};

export default tour;
